import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Lock, ArrowRight, Sparkles } from 'lucide-react';

const planNames = { starter: 'Starter', pro: 'Pro', enterprise: 'Tout-en-un' };
const planColors = {
  starter: 'from-slate-500 to-slate-600',
  pro: 'from-blue-500 to-indigo-600',
  enterprise: 'from-amber-500 to-orange-600',
};

const UpgradeGate = ({ requiredPlan = 'pro', currentPlan = 'starter', moduleName = '' }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="upgrade-gate">
      <div className="max-w-md text-center px-6">
        <div className={`w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br ${planColors[requiredPlan]} flex items-center justify-center shadow-lg`}>
          <Lock className="w-8 h-8 text-white" />
        </div>
        
        <h2 className="text-2xl font-bold text-slate-900 mb-2">
          Module {moduleName || requiredPlan}
        </h2>
        
        <p className="text-slate-600 mb-6">
          Cette fonctionnalite est disponible avec le plan <strong className="text-slate-900">{planNames[requiredPlan]}</strong>.
          {currentPlan === 'starter' && requiredPlan === 'pro' && (
            <span> Passez au Pro pour debloquer les modules RH, Paie, Shopify et plus.</span>
          )}
          {requiredPlan === 'enterprise' && (
            <span> Le plan Tout-en-un inclut l'assistant IA et un support dedie.</span>
          )}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate('/pricing')}
            className={`bg-gradient-to-r ${planColors[requiredPlan]} hover:opacity-90 text-white px-6`}
            data-testid="upgrade-btn"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Passer au {planNames[requiredPlan]}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/app/dashboard')}
            data-testid="back-dashboard-btn"
          >
            Retour au dashboard
          </Button>
        </div>

        <p className="text-xs text-slate-400 mt-6">
          Plan actuel : {planNames[currentPlan]}
        </p>
      </div>
    </div>
  );
};

export default UpgradeGate;
